import { c as _c } from "react/compiler-runtime";
import { APISource } from '../../../../../../../../typings/Source.interface';
import Container from '../../../../common/base/Container';
import ResourceMetricSection from '../ResourceMetricsSection';
export const SourceMetrics = t0 => {
  const $ = _c(2);
  const {
    source
  } = t0;
  let t1;
  if ($[0] !== source.id) {
    t1 = <Container left={true}><ResourceMetricSection id={source.id} resource="sources" default_relative_date="last_hour" /></Container>;
    $[0] = source.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};